import React from 'react';
import { wrapFunctionalComponent } from 'utils/framework';
import {
    fontSizes, fontWeights, mediaQueries, space
} from 'style/config';
import localeUtils from 'utils/LanguageLocale';
import { sumBundlePrices, formatBundlePrice } from 'components/ProductPage/PdpBundling/utils/bundlePrice';
import BundleWidgetEN from 'components/ProductPage/PdpBundling/BundleWidget/locales/BundleWidget_en_US';
import BundleWidgetFR from 'components/ProductPage/PdpBundling/BundleWidget/locales/BundleWidget_fr_CA';

const getText = localeUtils.getLocalisedDataFromResource(BundleWidgetEN, BundleWidgetFR);

const PriceTotal = ({ currentProduct, bundleProducts }) => {
    const total = sumBundlePrices([currentProduct, ...(bundleProducts || [])]);

    return (
        <div css={styles.container}>
            <span css={styles.text}>{getText('estimatedPrice')}</span>
            <span css={styles.text}>{formatBundlePrice(total)}</span>
        </div>
    );
};

const styles = {
    container: {
        display: 'flex',
        justifyContent: 'space-between',
        width: '100%',
        [mediaQueries.sm]: {
            justifyContent: 'flex-start',
            gap: space[2]
        }
    },
    text: {
        fontSize: fontSizes.md,
        fontWeight: fontWeights.bold
    }
};

export default wrapFunctionalComponent(PriceTotal, 'PriceTotal');
